import { render } from "./user-report-modal.vue?vue&type=template&id=e4e81526"
import script from "./user-report-modal.vue?vue&type=script&lang=js"
export * from "./user-report-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__